import { useTranslation } from 'react-i18next';
import { BottomSheet } from '../ui/BottomSheet';

interface AvatarPhotoLightboxProps {
  isOpen: boolean;
  onClose: () => void;
  imageUrl: string;
  username?: string;
}

/**
 * Enlarged profile photo for viewing others' avatars on the profile page.
 */
export function AvatarPhotoLightbox({ isOpen, onClose, imageUrl, username }: AvatarPhotoLightboxProps) {
  const { t } = useTranslation();

  if (!imageUrl) return null;

  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={onClose}
      title={t('profile.profilePhoto')}
      desktopMode="modal"
      desktopMaxWidthClass="max-w-lg"
      panelClassName="bg-gradient-to-b from-green-50/90 via-white to-white border-t border-accent-text/10 lg:border-0"
      contentClassName="px-0"
    >
      <div className="px-4 pb-8 pt-2 flex flex-col items-center gap-3">
        {username && (
          <p className="text-sm font-medium text-content/60 font-figtree">@{username}</p>
        )}
        <div className="w-full flex justify-center rounded-2xl overflow-hidden bg-gray-100 ring-1 ring-black/[0.06] shadow-inner">
          <img
            src={imageUrl}
            alt=""
            className="max-h-[min(78vh,560px)] w-full max-w-md object-contain"
          />
        </div>
      </div>
    </BottomSheet>
  );
}
